import { useQuery } from '@tanstack/react-query';

import { LiquiditySourcesParams } from '../utils/0x/swap/schema';
import { fetcher } from '../utils/fetcher';
import { routes } from '../utils/routes';
import { objectToQueryString } from '../utils/string';

export interface LiquiditySource {
  volume: number;
  volume30D: number;
  liquiditySource: string;
  timestamp: string;
  transactions: number;
  chains: string[];
}

interface UseLiquiditySourcesArgs {
  chainIds?: string[];
  time?: number;
  page?: number;
  searchTerm?: string;
}

interface UseLiquiditySourcesReturn {
  error: Error | null;
  liquiditySources: LiquiditySource[];
  totalSources: number;
  isLoading: boolean;
}

export const sourcesAllQueryKey = (params: Partial<LiquiditySourcesParams> & { page: number }) =>
  ['liquidity-sources-all', params] as const;

export function useSourcesAll({
  page = 1,
  chainIds,
  ...params
}: UseLiquiditySourcesArgs): UseLiquiditySourcesReturn {
  const queryParams: Partial<LiquiditySourcesParams> = params;

  if (chainIds) {
    queryParams.networks = chainIds.join();
  }

  const fullParams = { page, ...queryParams };
  const url = `${routes.api.SOURCES_ALL}${objectToQueryString(fullParams)}`;

  const { data, error, isLoading } = useQuery<
    { data: LiquiditySource[]; totalSources: number },
    Error
  >({
    queryKey: sourcesAllQueryKey(fullParams),
    queryFn: () => fetcher(url),
  });

  return {
    error,
    isLoading,
    liquiditySources: data?.data || [],
    totalSources: data?.totalSources || 0,
  };
}
